import { spacing, colors, shadows } from 'ui/theme';

export const SIZE = {
  small: spacing.half,
  medium: spacing.base,
  large: spacing.plusHalf,
};

export const VARIANT = {
  primary: colors.backgroundPrimary,
  secondary: colors.backgroundSecondary,
  tertiary: colors.backgroundTertiary,
};

export const SHADOW = {
  none: undefined,
  small: shadows.small.join(', '),
  subtle: shadows.subtle.join(', '),
};
